

export class ClientIds {
    public static readonly ALARMMONITORINGSERVICE = "AlarmMonitoringService";
    public static readonly ALARMNOTIFIER = "AssetWorxAlarmNotifier";
    public static readonly RADS = "AssetWorxRADS";
}